"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _checkIfPaymentSelected = _interopRequireDefault(require("../../utils/checkIfPaymentSelected"));
var _Addresses = _interopRequireDefault(require("./Addresses"));
var _Login = _interopRequireDefault(require("../Login01"));
var _Overview = _interopRequireDefault(require("./Overview"));
var _PaymentMethods = _interopRequireDefault(require("./PaymentMethods"));
var _Checkout = _interopRequireDefault(require("./Checkout01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Error = (0, _component.default)(function () {
  return import("../../components/Cart/Error");
});
var Preloader = (0, _component.default)(function () {
  return import("../../components/Preloader");
});
var Checkout01 = function Checkout01(_ref) {
  var _systemLink;
  var _ref$defaultLang = _ref.defaultLang,
    defaultLang = _ref$defaultLang === void 0 ? "de" : _ref$defaultLang;
  var _useContext = (0, _react.useContext)(_PageContext.default),
    _useContext2 = _slicedToArray(_useContext, 1),
    pageData = _useContext2[0];
  var _ref2 = pageData || {},
    pageDataLang = _ref2.lang;
  var _useContext3 = (0, _react.useContext)(_CartContext.default),
    cart = _useContext3.cart;
  var _ref3 = cart || {},
    address = _ref3.address,
    _ref3$isGuest = _ref3.isGuest,
    isGuest = _ref3$isGuest === void 0 ? false : _ref3$isGuest,
    _ref3$items = _ref3.items,
    items = _ref3$items === void 0 ? [] : _ref3$items,
    _ref3$paymentMethods = _ref3.paymentMethods,
    paymentMethods = _ref3$paymentMethods === void 0 ? [] : _ref3$paymentMethods,
    _ref3$_loading = _ref3._loading,
    _loading = _ref3$_loading === void 0 ? false : _ref3$_loading;
  var _useState = (0, _react.useState)(defaultLang),
    _useState2 = _slicedToArray(_useState, 2),
    lang = _useState2[0],
    setLang = _useState2[1];
  var navigate = (0, _useLink.default)();
  var systemLink = (0, _useSystemLinks.default)();
  var css = (0, _Checkout.default)();
  var isLoggedIn = !(0, _isEmpty.default)(localStorage.getItem("logintoken"));
  var shopUrl = (_systemLink = systemLink("shop")) !== null && _systemLink !== void 0 ? _systemLink : "/";
  (0, _react.useEffect)(function () {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  var handleShopClick = function handleShopClick() {
    navigate(shopUrl);
  };
  if (_loading) {
    return /*#__PURE__*/_react.default.createElement(Preloader, null);
  }
  if ((0, _isEmpty.default)(items)) {
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: (0, _clsx.default)(css.checkout, "mco-shop-checkout"),
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(Error, {
      lang: lang,
      onClick: handleShopClick
    }));
  }
  if ((isGuest || isLoggedIn) && (0, _isEmpty.default)(address)) {
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: (0, _clsx.default)(css.checkout, "mco-shop-checkout"),
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(_Addresses.default, {
      lang: lang,
      type: isGuest ? "guest" : null
    }));
  }
  if ((isGuest || isLoggedIn) && !(0, _isEmpty.default)(address) && !(0, _isEmpty.default)(paymentMethods) && !(0, _checkIfPaymentSelected.default)(paymentMethods)) {
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: (0, _clsx.default)(css.checkout, "mco-shop-checkout"),
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(_PaymentMethods.default, {
      defaultLang: lang
    }));
  }
  if ((isGuest || isLoggedIn) && (0, _checkIfPaymentSelected.default)(paymentMethods)) {
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: (0, _clsx.default)(css.checkout, "mco-shop-checkout"),
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "addresses/:type/*",
      element: /*#__PURE__*/_react.default.createElement(_Addresses.default, {
        lang: lang
      })
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "payment",
      element: /*#__PURE__*/_react.default.createElement(_PaymentMethods.default, {
        defaultLang: lang
      })
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      index: true,
      element: /*#__PURE__*/_react.default.createElement(_Overview.default, {
        defaultLang: lang
      })
    })));
  }
  if (!isLoggedIn && !isGuest) {
    return /*#__PURE__*/_react.default.createElement(_Login.default, {
      defaultLang: lang
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.checkout, "mco-shop-checkout"),
    maxWidth: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "addresses/:type/*",
    element: /*#__PURE__*/_react.default.createElement(_Addresses.default, {
      lang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "payment",
    element: /*#__PURE__*/_react.default.createElement(_PaymentMethods.default, {
      defaultLang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    index: true,
    element: /*#__PURE__*/_react.default.createElement(Preloader, {
      defaultLang: lang
    })
  })));
};
Checkout01.propTypes = {
  defaultLang: _propTypes.default.string
};
var _default = Checkout01;
exports.default = _default;